<ng-container *transloco="let t">
    <div class="or-container">
        <span class="or">{{t('shared_components.signing_forms.login_form.or')}}</span>
    </div>
    <div class="buttons">
        @if(supportsGoogleSignIn()){
            <button type="button" class="external-sign-in" (click)="handleGoogleSignIn()">
                <img [src]="'assets/images/g-logo.svg' | deployUrl" [alt]="t('shared_components.signing_forms.login_form.sign_in_with_google')"/>
            </button>
        }
        @if(supportsAppleSignIn()){
            <button type="button" class="external-sign-in apple" (click)="handleAppleSignIn()">
                <img [src]="'assets/icons/apple_sign_in_icon.svg' | deployUrl" [alt]="t('shared_components.signing_forms.login_form.sign_in_with_apple')"/>
            </button>
        }
    </div>
</ng-container>
